/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_How_It_WorksInputs */

const en_gift_how_it_works = /** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How Gifting Works`)
};

const es_gift_how_it_works = /** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo Funcionan los Regalos`)
};

const fr_gift_how_it_works = /** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment fonctionnent les cadeaux`)
};

const de_gift_how_it_works = /** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie Schenken funktioniert`)
};

const id_gift_how_it_works = /** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cara Kerja Hadiah`)
};

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const ja_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const zh_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const ar_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const it_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const ru_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const pt_gift_how_it_works = en_gift_how_it_works;

/** @type {(inputs: Gift_How_It_WorksInputs) => LocalizedString} */
const ko_gift_how_it_works = en_gift_how_it_works;

/**
* | output |
* | --- |
* | "How Gifting Works" |
*
* @param {Gift_How_It_WorksInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_how_it_works = /** @type {((inputs?: Gift_How_It_WorksInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_How_It_WorksInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_how_it_works(inputs)
	if (locale === "es") return es_gift_how_it_works(inputs)
	if (locale === "fr") return fr_gift_how_it_works(inputs)
	if (locale === "de") return de_gift_how_it_works(inputs)
	if (locale === "ja") return ja_gift_how_it_works(inputs)
	if (locale === "zh") return zh_gift_how_it_works(inputs)
	if (locale === "ar") return ar_gift_how_it_works(inputs)
	if (locale === "id") return id_gift_how_it_works(inputs)
	if (locale === "it") return it_gift_how_it_works(inputs)
	if (locale === "ru") return ru_gift_how_it_works(inputs)
	if (locale === "pt") return pt_gift_how_it_works(inputs)
	return ko_gift_how_it_works(inputs)
});